<template>
    <el-dialog
        v-if="dataDetail"
        title="反馈详情"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        custom-class="custom-dialog"
    >
        <div class="dialog-body">
            <div class="suggest-content" v-html="dataDetail.content"></div>
            <div v-if="screenshot.length > 0" class="suggest-imgs clearfix">
                <span
                    v-for="(item, index) in screenshot"
                    :key="index"
                    class="img fl"
                >
                    <el-image
                        :src="`${item}`"
                        fit="cover"
                        :preview-src-list="screenshot"
                    ></el-image>
                </span>
            </div>
			<div class="MT20" v-if="dataDetail.isHandle == 1">
				<el-input
				    v-model="dataDetail.remark"
				    placeholder="耐心,友好地回复......"
				    :maxlength="200"
				    type="textarea"
				    :rows="4"
				    show-word-limit
				></el-input>
			</div>
			 <div class="suggest-content MT20" v-if="dataDetail.isHandle == 2">
				 <span class="color-blue">回复内容：</span>{{dataDetail.remarks}}
			 </div>
			 <div class="MT10" v-if="dataDetail.isHandle == 2"><span class="color-blue">回复人：</span>{{dataDetail.modifyUserName}}</div>
			 <div class="MT10" v-if="dataDetail.isHandle == 2"><span class="color-blue">回复时间：</span>{{dataDetail.modifyTime}}</div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button
				:loading="btnLoading"
                v-if="dataDetail.isHandle == 1"
                type="primary"
                @click="updateHanderClick"
                >确认回复</el-button
            >           
            <el-button @click="dialogVisible = false" v-if="dataDetail.isHandle == 2">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        dataDetail: {
            type: Object,
            default: () => {
                return null;
            },
        },
    },
    data() {
        return {
            dialogVisible: false,
			btnLoading:false
        };
    },
    computed: {
        screenshot() {
            return this.dataDetail.screenshot ? this.dataDetail.screenshot.split(",") : [];
        },
    },
    methods: {
        show() {
            this.dialogVisible = true;
        },
        close(){
            this.dialogVisible = false;
        },
        updateHanderClick(){
           if( !this.dataDetail.remark){
			   this.$message.warning("请先填入回复的内容");
			   return
		   }
			this.btnLoading = true;
			this.$request({
			    url: "/suggest/remark",
			    method: "POST",
			    params: {id: this.dataDetail.id , remark:this.dataDetail.remark},
			})
			    .then((res) => {
			        const { state, msg } = res.data;
			        if (state == 1) {
			            this.$message.success("操作成功");
						this.close();
						this.$emit('onUpdate'); 
						this.btnLoading = false
			        } else {
			            this.$message.error(msg || "请求失败");
			        }
			    })
			    .catch(() => {
			        this.$message.error("请求错误");
			    })
        }
    },
};
</script>

<style lang="scss" scoped>
.suggest-imgs {
    margin-top: 10px;
    .img {
        margin: 10px 10px 0 0;
        width: 150px;
        height: 150px;
        .el-image {
            width: 100%;
            height: 100%;
        }
    }
}
@media screen and (max-width: 768px) {
    ::v-deep .custom-dialog {
        width: 95%;
    }
    .suggest-imgs {
        .img {
            width: 30%;
            height: 100px;
        }
    }
}

</style>